import React from 'react';
import {connect} from 'react-redux';
import {Button} from '../Presentation/Forms';
import {closePopup} from '../../actions/Popup';


//TODO make this different than the success popup
class FailPopup extends React.Component {
    constructor(props) {
        super(props);
        this.close = this.close.bind(this);
    }

    close() {
        this.props.dispatch(closePopup());
    }

    render() {
        return <div>
            <h3 className="text-center">{this.props.title}</h3>
            <div>{this.props.text}</div>
            <Button clickHandler={this.close} text="Ок" />
        </div>
    }
}

const mapStateToProps = (state) => {
    return {
        data: state.popup.popupData
    }
};

const mapDispatchToProps = (dispatch) => { return {dispatch} };

export default connect(mapStateToProps, mapDispatchToProps)(FailPopup);


// WEBPACK FOOTER //
// ./src/components/Popups/FailPopup.js